import {
  CLOSEAUTHOR,
  CLOSECATEGORY,
  GETAUTHOR,
  GETCATEGORY,
} from "./ActionType";
import initialState from "./initialState";

const PostReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETAUTHOR:
      return {
        ...state,
        authorName: action.payload,
      };
    case GETCATEGORY:
      return {
        ...state,
        category: action.payload,
      };
    case CLOSEAUTHOR:
      return {
        ...state,
        authorName: "",
      };
    case CLOSECATEGORY:
      return {
        ...state,
        category: "",
      };
    default:
      return state;
  }
};

export default PostReducer;
